export const ACCOUNT_STATEMENT = "ACCOUNT_STATEMENT";
export const ALL_GATEWAYS = "ALL_GATEWAYS";
export const SELECTED_GATEWAY = "SELECTED_GATEWAY";
